var map = {
	"./1.png": 6183,
	"./10.png": 5319,
	"./11.png": 1678,
	"./12.png": 4101,
	"./2.png": 2252,
	"./3.png": 4517,
	"./4.png": 4090,
	"./5.png": 9651,
	"./6.png": 4040,
	"./7.png": 5169,
	"./8.png": 3654,
	"./9.png": 5199
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 655;